import Joi from "joi";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";

import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import Toast from "../../helpers/Toast";
import useValidationSchema, { FieldConfig } from "../../components/Validations";

import { CheckListModelService } from "../../services/CheckListModelService";
import { CheckListModelDTO } from "../../models/CheckListModel/CheckListModelDTO";
import { CreateCheckListModelDTO, CreateCheckListModelDTOSchema} from "../../models/CheckListModel/CreateCheckListModelDTO";
import Routes from '../../helpers/Routes';

export default function CheckListModelCreate() {
    const intl = useIntl();
    const navigate = useNavigate();
    const service = new CheckListModelService();

    const [checkListModel, setCheckListModel] = useState<CheckListModelDTO>({} as CheckListModelDTO);
    const [loadingCreate, setLoadingCreate] = useState<boolean>(false);


    const schemaClientValidation = CreateCheckListModelDTOSchema;

    const createCheckListModel = async () => {
        setLoadingCreate(true);

        const { error } = schemaClientValidation.validate(checkListModel);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoadingCreate(false);
            return;
        }

        const createDTO: CreateCheckListModelDTO = {
            title: checkListModel.title,
            brand: checkListModel.brand,
            model: checkListModel.model,
        };

        const response = await service.Create(createDTO);

        if (!response.success) {
            Toast.Show("error", response.message);
            setLoadingCreate(false);
            return;
        }

        Toast.Show("success", response.message);

        // ✅ Navega diretamente para a rota de detalhes/adicionar tarefas
        navigate(`${Routes.checkListModels.details}/${response.obj}`);
    };

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={intl.formatMessage({ id: "Screens.CheckListModel.Create.Title" })} allowGoBack={true} />
                </div>
                <div className="pageBody">
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>Detalhes do Modelo de Checklist</b>
                    </label>
                    <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end" }}>
                        <Row>
                            <InputComponent
                                xl={6} lg={12} md={12} sm={12} xs={12}
                                type="text"
                                label={intl.formatMessage({ id: "Screens.CheckListModel.Create.Info.Title" })}
                                value={checkListModel?.title}
                                onChange={(t: string) => setCheckListModel({ ...checkListModel, title: t })}
                            />
                        </Row>
                        <Row>
                            <InputComponent
                                xl={6} lg={12} md={12} sm={12} xs={12}
                                type="text"
                                label={intl.formatMessage({ id: "Screens.CheckListModel.Create.Info.Brand" })}
                                value={checkListModel?.brand}
                                onChange={(t: string) => setCheckListModel({ ...checkListModel, brand: t })}
                            />
                        </Row>
                        <Row>
                            <InputComponent
                                xl={6} lg={12} md={12} sm={12} xs={12}
                                type="text"
                                label={intl.formatMessage({ id: "Screens.CheckListModel.Create.Info.Model" })}
                                value={checkListModel?.model}
                                onChange={(t: string) => setCheckListModel({ ...checkListModel, model: t })}
                            />
                        </Row>
                    </Row>

                    <Row style={{ marginTop: "2rem" }}>
                        <Col xl={2} lg={3} md={4} sm={6} xs={12}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Screens.CheckListModel.Create.Button.Create" })}
                                loading={loadingCreate}
                                onClick={createCheckListModel}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}
